<template>

    <m-edit1/>

    <m-factor-4 v-bind='{...{"sellerName":"\u0645\u06cc\u06a9\u0633\u06cc\u062a \u0648\u0628","addressProp":"","meliProp":"","signature":"","secondImageFactor":""},...{}}' :style='""' class="my-5 py-5" ></m-factor-4>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor4 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor4';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
